import { createContext } from 'react';

export const AuthContext = createContext({
  user: null,
  roles: [],
  primaryRole: null,
  loading: true,
  signOut: async () => {}
});
